import { PLATFORM } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { ENTITY } from '../constant';

const apiEndPoint = constants.ADMIN_URL;

export const getPlatformList = (object) => (dispatch) => {
  let query;
  if (object) {
    query = `${constants.API.SOFTWARE_MODULE_PLATFORM}/${object.id}`;
  } else {
    query = `${constants.API.PLATFORM}`;
  }
  dispatch({
    payload: [],
    type: PLATFORM.DATA.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      const {
        rows = [],
        count = 0,
      } = response.data.response;

      const responseData = rows.map((data) => (
        {
          ...data,
          platform: `${data.platform.charAt(0).toUpperCase()}${data.platform.slice(1)}`,
          created_at: dateFormat(data.createdAt),
          created_by: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: PLATFORM.DATA.SUCCESS,
      });
      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: PLATFORM.DATA.ERROR,
      });
    });
};

export const doPlatformCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.PLATFORM}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doPlatformUpdate = (Id, data) => {
  const endPointUri = constants.API.PLATFORM_BY_ID.replace(ENTITY.PLATFORM_ID, Id);
  return httpservice()
    .put(endPointUri, data)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const doPlatformDelete = (Id) => {
  const endPointUri = constants.API.PLATFORM_BY_ID.replace(ENTITY.PLATFORM_ID, Id);
  return httpservice()
    .delete(endPointUri)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};
